import { MenuRoute } from '../../shared/menu/menu-route.model';

/**
 * Menu-eligible routes exposed by the Checklist / HMS module.
 * Only static (non-parameterized) routes are listed.
 */
export const CHECKLIST_MENU_ROUTES: MenuRoute[] = [
  {
    path: '/checklist/dashboard',
    labelKey: 'Hms.dashboard',
    icon: '/assets/tablerIcons/outline/layout-dashboard.svg',
    moduleId: 35,
    groupLabelKey: 'MenuRoutes.group.hmsOverview'
  },
  {
    path: '/checklist/hms-report',
    labelKey: 'Hms.report',
    icon: '/assets/tablerIcons/outline/report.svg',
    moduleId: 35,
    groupLabelKey: 'MenuRoutes.group.hmsOverview'
  },
  {
    path: '/checklist/my-actions',
    labelKey: 'Hms.myActions.title',
    icon: '/assets/tablerIcons/outline/user-check.svg',
    moduleId: 35,
    groupLabelKey: 'MenuRoutes.group.hmsOverview'
  },
  {
    path: '/checklist/templates',
    labelKey: 'Hms.templates',
    icon: '/assets/tablerIcons/outline/template.svg',
    moduleId: 35,
    groupLabelKey: 'MenuRoutes.group.hmsChecklists'
  },
  {
    path: '/checklist/executions',
    labelKey: 'Hms.executions',
    icon: '/assets/tablerIcons/outline/clipboard-check.svg',
    moduleId: 35,
    groupLabelKey: 'MenuRoutes.group.hmsChecklists'
  },
  {
    path: '/checklist/deviations',
    labelKey: 'Hms.deviations',
    icon: '/assets/tablerIcons/outline/alert-triangle.svg',
    moduleId: 35,
    groupLabelKey: 'MenuRoutes.group.hmsDeviations'
  },
  {
    path: '/checklist/safety-rounds',
    labelKey: 'Hms.safetyRounds',
    icon: '/assets/tablerIcons/outline/shield-check.svg',
    moduleId: 35,
    groupLabelKey: 'MenuRoutes.group.hmsDeviations'
  },
  {
    path: '/checklist/handlingsplan',
    labelKey: 'Hms.actionPlan',
    icon: '/assets/tablerIcons/outline/list-check.svg',
    moduleId: 35,
    groupLabelKey: 'MenuRoutes.group.hmsDeviations'
  },
  {
    path: '/checklist/risk-assessment',
    labelKey: 'Hms.riskAssessment',
    icon: '/assets/tablerIcons/outline/alert-octagon.svg',
    moduleId: 35,
    groupLabelKey: 'MenuRoutes.group.hmsRisk'
  },
  {
    path: '/checklist/goals',
    labelKey: 'Hms.goals',
    icon: '/assets/tablerIcons/outline/target.svg',
    moduleId: 35,
    groupLabelKey: 'MenuRoutes.group.hmsRisk'
  },
  {
    path: '/checklist/internal-control',
    labelKey: 'Hms.internalControl',
    icon: '/assets/tablerIcons/outline/file-check.svg',
    moduleId: 35,
    groupLabelKey: 'MenuRoutes.group.hmsRisk'
  },
  {
    path: '/checklist/internal-control/review',
    labelKey: 'Hms.internalControlReview',
    icon: '/assets/tablerIcons/outline/file-search.svg',
    moduleId: 35,
    groupLabelKey: 'MenuRoutes.group.hmsRisk'
  },
  {
    path: '/checklist/suggestion-box',
    labelKey: 'Hms.suggestionBox',
    icon: '/assets/tablerIcons/outline/bulb.svg',
    moduleId: 35,
    groupLabelKey: 'MenuRoutes.group.hmsSuggestions'
  },
  {
    path: '/checklist/suggestion-box-admin',
    labelKey: 'Hms.suggestionBoxAdmin',
    icon: '/assets/tablerIcons/outline/bulb-filled.svg',
    moduleId: 35,
    groupLabelKey: 'MenuRoutes.group.hmsSuggestions',
    requiresAdmin: true
  },
  {
    path: '/checklist/document-library',
    labelKey: 'Hms.documentLibrary',
    icon: '/assets/tablerIcons/outline/folder.svg',
    moduleId: 35,
    groupLabelKey: 'MenuRoutes.group.hmsLibrary'
  },
  {
    path: '/checklist/chemical-registry',
    labelKey: 'Hms.chemicalRegistry',
    icon: '/assets/tablerIcons/outline/flask.svg',
    moduleId: 35,
    groupLabelKey: 'MenuRoutes.group.hmsChemical'
  },
  {
    path: '/checklist/chemical-dashboard',
    labelKey: 'Hms.chemicalDashboard',
    icon: '/assets/tablerIcons/outline/chart-donut.svg',
    moduleId: 35,
    groupLabelKey: 'MenuRoutes.group.hmsChemical'
  }
];
